<button
  class="btn btn-ghost btn-untextured social-icon"
  [tp]="'View Changelog'"
  [style.--social-color]="color"
  (mouseenter)="currentColor = color"
  (mouseleave)="currentColor = '#ccc'"
  appModalOpen="changelog"
  appSfx="ui-click"
  [sfxOffset]="4"
  [sfxTrigger]="['click', 'hover']"
>
  <ng-icon [name]="'tablerPackage'" [color]="currentColor || '#ccc'"></ng-icon>
</button>

<div *appTeleportTo="'changelog-modal'">
  <app-modal modalId="changelog" [allowEscToClose]="true">
    <span title>Changelog</span>

    <div body>
      <div role="tablist" class="tabs tabs-box mt-1">
        <button
          type="button"
          role="tab"
          class="tab"
          [class.tab-active]="currentView() === 'recent'"
          [attr.aria-selected]="currentView() === 'recent'"
          (click)="currentView.set('recent')"
          appSfx="ui-click"
          [sfxTrigger]="['click', 'hover']"
        >
          Recent
        </button>
        <button
          type="button"
          role="tab"
          class="tab"
          [class.tab-active]="currentView() === 'all'"
          [attr.aria-selected]="currentView() === 'all'"
          (click)="currentView.set('all')"
          appSfx="ui-click"
          [sfxTrigger]="['click', 'hover']"
        >
          All
        </button>
      </div>

      <div class="changelog p-1 my-4 overflow-hidden overflow-y-auto max-h-72">
        @for (section of sections(); track section.key) {
          <section #section [innerHTML]="section.html"></section>
        }
      </div>
    </div>

    <div actions>
      <button
        class="btn btn-neutral"
        appModalClose
        appSfx="ui-click"
        [sfxTrigger]="['click', 'hover']"
      >
        Close
      </button>
    </div>
  </app-modal>
</div>
